import { createContext, useEffect, useState } from "react";
import {
  login as loginAPI,
  getCurrentUser,
} from "../api/auth";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // ───────────────────────────────────────────────
  // LOAD USER SESSION (COOKIE)
  // ───────────────────────────────────────────────
  const loadUser = async () => {
    try {
      const res = await getCurrentUser();
      setUser(res.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadUser();
  }, []);

  // ───────────────────────────────────────────────
  // LOGIN
  // ───────────────────────────────────────────────
  const login = async (credentials) => {
    try {
      const res = await loginAPI(credentials);

      // cookie déjà enregistré par le navigateur
      await loadUser();

      return {
        success: true,
        status: res.status,
        message: res.data?.message || "Login successful",
      };
    } catch (error) {
      return {
        success: false,
        status: error.response?.status || 500,
        message:
          error.response?.data?.message ||
          "Invalid credentials",
      };
    }
  };

  // ───────────────────────────────────────────────
  // LOGOUT
  // ───────────────────────────────────────────────
  const logout = async () => {
    try {
      await fetch("https://auth.teqaconnect.com/auth/logout/", {
        method: "POST",
        credentials: "include",
      });
    } finally {
      setUser(null);
    }
  };

  // ───────────────────────────────────────────────
  // REDIRECT BY ROLE
  // ───────────────────────────────────────────────
  const redirectByRole = () => {
    if (!user) return;

    switch (user.role) {
      case "ADMIN" :
        window.location.href = "https://admin.teqaconnect.com/";
        break;
      case "STORE":
        window.location.href = "https://app.teqaconnect.com/";
        break;
      case "AGENCY_OWNER":
      case "AGENCY_AGENT":
        window.location.href = "https://confirmation.teqaconnect.com/";
        break;
      default:
        break;
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        logout,
        loadUser,
        redirectByRole,
        isAuthenticated: !!user,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
